import { useColoResource } from './useColoResource';
import { isSlug } from './isSlug';
import { GiftCard, Invoice } from 'olo-service';
import { useMemo } from 'react';
import { formatSummary } from 'olo-service/Order';
import { toCents } from 'util/Formatting';

export function useTableOrderCheckoutResource(merchantId?: string, tableUuid?: string,tipValue:number=0,appliedGiftCards?:GiftCard[]) {

  const [isInvoiceSummaryLoading, invoice, invoiceSummaryError] = useColoResource<Invoice>(() => merchantId && tableUuid && ({
    method: 'POST',
    url: `${merchantId}/tables/${tableUuid}/order/checkout`,
    params: { slug: isSlug(merchantId) },
    data:{ tipAmount :  toCents(tipValue),
       ...(!!appliedGiftCards?.length && { giftSources: appliedGiftCards }) },
  }), [merchantId, tableUuid,tipValue,appliedGiftCards]);

  const invoiceSummary = useMemo(() => !invoice ? undefined : formatSummary(invoice), [invoice]);

  return { isInvoiceSummaryLoading, invoiceSummary, invoiceSummaryError };
}
